import { render, staticRenderFns } from "./BasicPlanIcon.vue?vue&type=template&id=1442dc3a"
import script from "./BasicPlanIcon.vue?vue&type=script&lang=js"
export * from "./BasicPlanIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports